// One deliberate, audience/theme-independent unread-attention colour.
export const CHAT_UNREAD_BADGE = Object.freeze({ background: '#ef5766', foreground: '#ffffff' });
